import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoInnovacion from "../home/InfoInnovacion";
const Footer = lazy(() => import('../footer/Footer'));
function Innovacion() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai se está centrando en tecnologías que se puede aplicar a la mayor cantidad de autos de pasajeros posible."
        />
        <meta
          name="keywords"
          content="Hyundai, autos, sedan, hatchback"
        />
        <title>Hyundai Innovación</title>
      </Helmet>
      <Menu />
      <InfoInnovacion />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Innovacion;